import { createSlice } from '@reduxjs/toolkit'

import {
  reactivateSubscription as removeDowngradeReactivateSubscription
} from 'features/billing/actions/reactivate_subscription'

import { fetchNextBill } from './actions/fetch_next_bill'
import {
  reactivateSubscription as currentSubscriptionReactivateSubscription
} from './stages/paid_stage/reactivation_popup/slice'

const nextBillSlice = createSlice({
  name: 'nextBill',
  initialState: {
    error: null,
    loading: true,

    // actual next_bill data
    plan_id: null,
    plan_tier: null,
    amount_due: null,
    plan_unit_price: null,
    plan_quantity: null,
    plan_sub_total: null,
    resume_from_pause_date: null,
    scheduled_pause_date: null,
    billing_date: null,
    discounts: null,
    tax_amount: null,
    credit_amount: null,
    addons: null,
    line_item_tiers: null
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNextBill.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchNextBill.fulfilled, (state, action) => {
      state.loading = false
      state.error = null

      // actual next_bill data
      state.plan_id = action.payload.plan_id
      state.plan_tier = action.payload.plan_tier
      state.amount_due = action.payload.amount_due
      state.plan_unit_price = action.payload.plan_unit_price
      state.plan_quantity = action.payload.plan_quantity
      state.plan_sub_total = action.payload.plan_sub_total
      state.resume_from_pause_date = action.payload.resume_from_pause_date
      state.scheduled_pause_date = action.payload.scheduled_pause_date
      state.billing_date = action.payload.billing_date
      state.discounts = action.payload.discounts
      state.tax_amount = action.payload.tax_amount
      state.credit_amount = action.payload.credit_amount
      state.addons = action.payload.addons || []
      state.line_item_tiers = action.payload.line_item_tiers
    })
    builder.addCase(fetchNextBill.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    // NOTE: Needed here to mirror `currentSubscriptionSlice`'s
    // `reactivateSubscription.fulfilled` case.
    //
    // This is set on successful completion of 'currentSubscription/reactivate'.
    //
    builder.addCase(currentSubscriptionReactivateSubscription.fulfilled, (state, action) => {
      // console.log('nextbill currentSubscriptionReactivateSubscription.fulfilled')
      const nextBill = action.payload.next_bill

      state.plan_id = nextBill.plan_id
      state.plan_tier = nextBill.plan_tier
      state.amount_due = nextBill.amount_due
      state.plan_unit_price = nextBill.plan_unit_price
      state.plan_quantity = nextBill.plan_quantity
      state.plan_sub_total = nextBill.plan_sub_total
      state.resume_from_pause_date = nextBill.resume_from_pause_date
      state.scheduled_pause_date = nextBill.scheduled_pause_date
      state.billing_date = nextBill.billing_date
      state.discounts = nextBill.discounts
      state.tax_amount = nextBill.tax_amount
      state.credit_amount = nextBill.credit_amount
      state.addons = nextBill.addons
      state.line_item_tiers = nextBill.line_item_tiers
    })
    // This is set on successful completion of 'removeDowngrade/reactivateSubscription'.
    builder.addCase(removeDowngradeReactivateSubscription.fulfilled, (state, action) => {
      // console.log('nextbill removeDowngradeReactivateSubscription.fulfilled')
      const nextBill = action.payload.next_bill

      state.plan_id = nextBill.plan_id
      state.plan_tier = nextBill.plan_tier
      state.amount_due = nextBill.amount_due
      state.plan_unit_price = nextBill.plan_unit_price
      state.plan_quantity = nextBill.plan_quantity
      state.plan_sub_total = nextBill.plan_sub_total
      state.resume_from_pause_date = nextBill.resume_from_pause_date
      state.scheduled_pause_date = nextBill.scheduled_pause_date
      state.billing_date = nextBill.billing_date
      state.discounts = nextBill.discounts
      state.tax_amount = nextBill.tax_amount
      state.credit_amount = nextBill.credit_amount
      state.addons = nextBill.addons
      state.line_item_tiers = nextBill.line_item_tiers
    })
  }
})

export const { reducer } = nextBillSlice
